import styled from '@emotion/styled';
import MBDialog from 'components/Elements/MBDialog';

export const SortDialog = styled(MBDialog)`
  .MuiDialogContent-root {
    padding-top: 20px !important;
  }
`;
